import { render, staticRenderFns } from "./svgEmalls.vue?vue&type=template&id=6e7cbcca"
import script from "./svgEmalls.vue?vue&type=script&lang=js"
export * from "./svgEmalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports